import { render, staticRenderFns } from "./productionShow.vue?vue&type=template&id=6f5c8910&scoped=true&"
import script from "./productionShow.vue?vue&type=script&lang=js&"
export * from "./productionShow.vue?vue&type=script&lang=js&"
import style0 from "./productionShow.vue?vue&type=style&index=0&id=6f5c8910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c8910",
  null
  
)

export default component.exports